import api from "../../../services/api";

const APIS = {
  TASKS_DATA: "/Tasks/tasks/final-review",
  REJECT_FINAL_REVIEW_DATA: "/SampleStatus/markAsFinalRejected",
  RELEASE_TO_CUSTOMER_DATA: "/Sample/releasesampletocustomer",
  //__________________PEER REVIEW APIS_________________________//
  ACCEPT_AND_REJECT_PEERDATA: "/SampleStatus/updatePeerReviewStatus",
  PEER_REVIEW_POST_DATA: "/Sample/peer-review-samples",
};

export const getTasksData = async (params) => {
  try {
    const response = await api.get(APIS.TASKS_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks all data:", error);
    throw error;
  }
};
export const releaseToCustomerFinalData = async (payload) => {
  try {
    const response = await api.post(APIS.RELEASE_TO_CUSTOMER_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks received data:", error);
    throw error;
  }
};
export const rejectFinalData = async (payload) => {
  try {
    const response = await api.post(APIS.REJECT_FINAL_REVIEW_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks rejected data:", error);
    throw error;
  }
};

//__________________PEER REVIEW APIS_________________________//
export const getPeerReviewData = async (payload) => {
  try {
    const response = await api.post(APIS.PEER_REVIEW_POST_DATA,  payload );
    return response.data;
  } catch (error) {
    console.error("Error fetching Peer Review data:", error);
    throw error;
  }
};
export const acceptAndRejectPeerReview = async (payload) => {
  try {
    const response = await api.post(APIS.ACCEPT_AND_REJECT_PEERDATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks accepted data:", error);
    throw error;
  }
};
